import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import { VH_LUCIDE_ICONS } from './vh-icons';

function toLucideProviderName(name: string): string {
  return name.replace(
    /(\w)([a-z0-9]*)(_|-|\s*)/g,
    (_, firstChar: string, rest: string) => firstChar.toUpperCase() + rest.toLowerCase(),
  );
}

const VH_LUCIDE_PROVIDER_ICONS = Object.fromEntries(
  Object.entries(VH_LUCIDE_ICONS).map(([name, icon]) => [toLucideProviderName(name), icon]),
);

/**
 * Registers the curated VendorHub icon set with lucide-angular. Call
 * from each app's `app.config.ts` so `<vh-icon name="...">` can resolve
 * icons without importing them individually at the component level.
 */
export function provideVhIcons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: LUCIDE_ICONS,
      multi: true,
      useValue: new LucideIconProvider(VH_LUCIDE_PROVIDER_ICONS),
    },
  ]);
}
